import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector, useDispatch } from "react-redux";
import { search } from "store/vino/productsSlice";

const Search = () => {
	const dispatch = useDispatch();
	const searchText = useSelector((state) => state.vino.products.searchText);

	const handleChange = (event) => {
		const { value } = event.target;
		dispatch(search(value));
	};

	return (
		<div className="input-group">
			<TextField
				value={searchText}
				onChange={handleChange}
				className="w-full"
				size="small"
				placeholder="Search"
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				}}
				variant="standard"
			/>
		</div>
	);
};

export default Search;
